import { render, staticRenderFns } from "./WebinarTambah.vue?vue&type=template&id=00222abc&"
import script from "./WebinarTambah.vue?vue&type=script&lang=js&"
export * from "./WebinarTambah.vue?vue&type=script&lang=js&"
import style0 from "./WebinarTambah.vue?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports